import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './../assets/logo.png';

const Navigation = ({ onQuoteClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-14 h-14 bg-gradient-to-br from-black to-black rounded-lg flex items-center justify-center">
              <img src={ Logo } alt="GUS GROUP"/>
            </div>
            <div>
              <h1 className="text-xl font-bold text-yellow-400">GUS GROUP LTD</h1>
              <p className="text-xs text-gray-400">Excellence in Construction</p>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`transition-colors ${isActive('/') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`transition-colors ${isActive('/about') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`transition-colors ${isActive('/services') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
            >
              Services
            </Link>
            <Link 
              to="/portfolio" 
              className={`transition-colors ${isActive('/portfolio') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
            >
              Portfolio
            </Link>
            <Link 
              to="/contact" 
              className={`transition-colors ${isActive('/contact') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
            >
              Contact
            </Link>
            <button 
              onClick={onQuoteClick}
              className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition-all transform hover:scale-105"
            >
              Get Quote
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md py-4 space-y-4">
            <Link 
              to="/" 
              className={`block py-2 transition-colors ${isActive('/') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`block py-2 transition-colors ${isActive('/about') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`block py-2 transition-colors ${isActive('/services') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </Link>
            <Link 
              to="/portfolio" 
              className={`block py-2 transition-colors ${isActive('/portfolio') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Portfolio
            </Link>
            <Link 
              to="/contact" 
              className={`block py-2 transition-colors ${isActive('/contact') ? 'text-yellow-400' : 'text-white hover:text-yellow-400'}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
            <button 
              onClick={() => {
                onQuoteClick();
                setMobileMenuOpen(false);
              }}
              className="w-full bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold"
            >
              Get Quote
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;